import styled from "styled-components/macro";

import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";

import FnrButton from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

export default function MoreInfoPopover({
  buttonRef,
  show,
  onShouldClose,
  fund = {},
  toggle,
}) {
  const { name, description } = fund;
  const { noun } = useGetPaymentTypeVerbiage();

  return (
    <FnrPopover buttonRef={buttonRef} show={show} onShouldClose={onShouldClose}>
      <Wrapper>
        <Name>{name}</Name>
        <Description>{description}</Description>
        <ButtonsWrapper>
          <FnrButton onClick={onShouldClose}>Cancel</FnrButton>
          <FnrButton onClick={() => toggle(true)} color="blue">
            Add this to my {noun}
          </FnrButton>
        </ButtonsWrapper>
      </Wrapper>
    </FnrPopover>
  );
}

const Wrapper = styled.div`
  padding: 6px 10px;
  padding-bottom: 10px;
  max-width: 340px;
`;

const Name = styled.div`
  font-size: 20px;
  margin-bottom: 4px;
`;

const Description = styled.div``;

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
